import { Entry } from "@/components/Price/label/components/entry";
import { Base } from "@/components/Price/label/label.base";

export const Label = Object.assign(Base, {
    Entry: Entry
});
